import React, { useContext } from "react";

// import PeoplePicker from "../../Macros/Shared/Components/PeoplePicker";
import { BackgroundDialogContext } from "../Context";

function Users() {
  const { image, setImage } = useContext(BackgroundDialogContext);

  return (
    <div style={{ marginTop: "10px" }}>
      {/* <PeoplePicker
        initialAccountIDs={[image.id || ""]}
        isMulti={false}
        placeholder="Add people"
        onUpdate={(newPerson) => {
          setImage({
            source: "user",
            link: newPerson.avatarUrl,
            id: newPerson.value,
          });
        }}
      /> */}
    </div>
  );
}

export default Users;
